import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ThemeDto} from '../model/Theme';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    private baseUrl = `${environment.apiBaseUrl}/themes`;

    constructor(private http: HttpClient) {
    }

    getAllThemes(): Observable<ThemeDto[]> {
        return this.http.get<ThemeDto[]>(`${this.baseUrl}`);
    }

    getById(id: string): Observable<ThemeDto> {
        return this.http.get<ThemeDto>(`${this.baseUrl}/${id}`);
    }

    create(payload: FormData) {
        return this.http.post<ThemeDto>(`${this.baseUrl}`, payload);
    }

    remove(id: string) {
        return this.http.delete(`${this.baseUrl}/${id}`);
    }

    update(theme: ThemeDto): Observable<ThemeDto> {
        return this.http.put<ThemeDto>(`${this.baseUrl}`, theme);
    }

    updateFile(id: string, payload: FormData) {
        return this.http.post(`${this.baseUrl}/${id}/indd`, payload);
    }

    getInddFile(themeId: string): Observable<ArrayBuffer> {
        return this.http.get(`${this.baseUrl}/${themeId}/file`, {
            responseType: "arraybuffer",
        });
    }

    getThemePreview(id: string) {
        return `${this.baseUrl}/${id}/preview`;
    }

    getPreviewPage(themeId: string, pageId: string): Observable<Blob> {
        return this.http.get(`${this.baseUrl}/${themeId}/preview-pages/${pageId}`, {
            responseType: 'blob'
        });
    }

    addPreviewPage(id: string, file: File, name: string): Observable<ThemeDto> {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('name', name);
        return this.http.post<ThemeDto>(`${this.baseUrl}/${id}/preview-pages`, formData);
    }

    reorderPreviewPages(id: string, orderedPageIds: string[]): Observable<ThemeDto> {
        return this.http.put<ThemeDto>(`${this.baseUrl}/${id}/preview-pages/reorder`, orderedPageIds);
    }

    deletePreviewPage(id: string, pageId: string): Observable<ThemeDto> {
        return this.http.delete<ThemeDto>(`${this.baseUrl}/${id}/preview-pages/${pageId}`);
    }

}
